(function () {
	function swiperInit() {
		subSliderInit(true, 16);
		sliderInit(true);
		popupSliderInit(true);
	}

	// --- FIX ---
	// swiper-boot.js carga Swiper de forma perezosa y expone
	// window.themeSwiperReady (una Promise) que se resuelve cuando la
	// librería ya está disponible en window. Antes, swiperInit() se
	// llamaba de inmediato al cargar este script, sin esperar esa
	// promesa. En la primera carga de una página de producto, casi
	// siempre gana la carrera el script y Swiper todavía no existe,
	// por lo que `new Swiper(...)` dentro de subSliderInit/sliderInit/
	// popupSliderInit fallaba y la galería de imágenes (imagen
	// principal, miniaturas y zoom) quedaba sin inicializar: las
	// imágenes se veían "crudas" y los clics no hacían nada.
	// runWhenSwiperReady() espera esa promesa (con fallback si no
	// existe) antes de llamar a swiperInit().
	function runWhenSwiperReady() {
		if (typeof Swiper !== 'undefined') {
			swiperInit();
			return;
		}

		if (window.themeSwiperReady && typeof window.themeSwiperReady.then === 'function') {
			window.themeSwiperReady
				.then(() => swiperInit())
				.catch((err) => {
					console.warn('[update-slider] No se pudo cargar Swiper:', err);
				});
			return;
		}

		// Fallback defensivo por si swiper-boot.js no está presente en
		// esta plantilla: reintenta brevemente antes de rendirse.
		let attempts = 0;
		const poll = setInterval(() => {
			attempts += 1;
			if (typeof Swiper !== 'undefined') {
				clearInterval(poll);
				swiperInit();
			} else if (attempts > 20) {
				clearInterval(poll);
				console.warn('[update-slider] Swiper nunca llegó a cargar; se omite la galería.');
			}
		}, 150);
	}
	// --- FIN FIX ---

	document.addEventListener('shopify:section:load', function (e) {
		runWhenSwiperReady();
	});

	runWhenSwiperReady();
})();